<template>
  <div class="subordermanager">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">周期任务</a></li>
        </ul>
      </nav>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      class="messagelist">
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        width="70">
      </el-table-column>
      <el-table-column
        label="名称"
        align="center"
        width="160">
        <template slot-scope="scope">
          <el-link :underline="false" @click="toSubscriptionOrder(scope.row.id)" >{{scope.row.productName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="periodValue"
        label="周期"
        align="center"
        width="70">
      </el-table-column>
      <el-table-column
        prop="periodType"
        label="单位"
        align="center"
        width="70">
      </el-table-column>
      <el-table-column
        label="开始时间"
        align="center"
        width="100">
        <template slot-scope="scope">
          <a>{{ scope.row.taskStartDate }} {{ scope.row.time }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="nextRunTime"
        label="下次执行时间"
        align="center"
        width="110">
      </el-table-column>
      <el-table-column
        label="运行状态"
        align="center"
        width="80">
        <template slot-scope="scope">
          <a>{{ scope.row.triggerStatus === '0' ? '运行中' : '已停止' }}</a>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        >
        <template slot-scope="scope">
          <a href="javascript:;" @click="orderDetail(scope.row)" class="lookfor">查看</a>
          <a href="javascript:;" @click="updateTriggerStatus(scope.row.id,1,'停止')" class="lookfor" v-if="scope.row.triggerStatus == 0">停止</a>
          <a href="javascript:;" @click="updateTriggerStatus(scope.row.id,0,'启动')" class="lookfor" v-else>启动</a>
          <a href="javascript:;" @click="updateTriggerStatus(scope.row.id,2,'删除')" class="lookfor">删除</a>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>pageSize">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        background
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="任务详情" :visible.sync="dialogFormVisible" :append-to-body='true' custom-class="suborderdialog">
      <subscriptionOrderDetail :model="item" :dialogFormVisible="dialogFormVisible" @onDialogVisible="onDialogVisible"></subscriptionOrderDetail>
    </el-dialog>
  </div>
</template>
<script>
import subscriptionOrderDetail from '@/components/order/SubscriptionOrderDetail.vue'
export default {
  name: 'subscriptionOrders',
  components: {
    'subscriptionOrderDetail': subscriptionOrderDetail
  },
  created () {
    this.orderList()
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 5,
      total: 0,
      dialogFormVisible: false,
      item: {
        id: '',
        name: '',
        triggerStatus: '',
        dataStartDate: '',
        dataEndDate: '',
        periodValue: '',
        periodType: '',
        type: '',
        desc: '',
        taskStartDate: '',
        taskEndDate: '',
        time: '',
        nextRunTime: '',
        regionType: '',
        deliveryType: '',
        ftpId: '',
        addressId: '',
        dataStationId: '',
        status: ''
      },
      tableData: []
    }
  },
  methods: {
    orderList() {
      let queryParam = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.sapost('/dmc/subscriptionOrder/orderQuery', queryParam, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.tableData = pager.list
        } else {
          this.$message.warning(retMsg)
        }
      })
    },
    orderDetail (p) {
      let triggerStatus = p.triggerStatus === '0' ? '运行中' : '已停止'
      let taskStartTime = p.taskStartDate + ' ' + p.time
      // 交付方式(0云盘、1FTP、2离线硬盘
      let deliveryType = '下载'
      if (p.deliveryType === '1') {
        deliveryType = '推送'
      } else if (p.deliveryType === '2') {
        deliveryType = '离线邮寄'
      }
      // 订单状态(init、ordering、ordered、completed、canceld)
      let status = '待下单'
      if (p.status === 'ordering') {
        status = '下单中'
      } else if (p.status === 'ordered') {
        status = '下单完成'
      } else if (p.status === 'completed') {
        status = '生产完成'
      } else if (p.status === 'canceld') {
        status = '已删除'
      }
      this.item = {
        id: p.id,
        name: p.productName,
        triggerStatus: triggerStatus,
        dataStartDate: p.dataStartDate,
        dataEndDate: p.dataEndDate,
        periodValue: p.periodValue,
        periodType: p.periodType,
        type: p.type,
        desc: p.desc,
        taskStartTime: taskStartTime,
        taskEndDate: p.taskEndDate,
        nextRunTime: p.nextRunTime,
        regionType: p.regionType,
        deliveryType: deliveryType,
        ftpId: p.ftpId,
        addressId: p.addressId,
        dataStationId: p.dataStationId,
        status: status
      }
      this.dialogFormVisible = true
    },
    updateTriggerStatus(id, type, desc) {
      let queryParam = {
        schedule_order_id: id,
        type: type
      }
      this.sapost('/dmc/subscriptionOrder/orderStatusUpdate', queryParam, r => {
        let { retMsg, retCode } = r.data
        if (retCode === '0') {
          this.$message.success('周期性订单' + desc + '成功！')
          this.orderList()
        } else {
          this.$message.warning(retMsg)
        }
      })
    },
    onDialogVisible(val) {
      this.dialogFormVisible = val
    },
    handleSizeChange (val) {
      console.log('当前页数发生改变')
      this.pageSize = val
      this.orderList()
    },
    handleCurrentChange (val) {
      console.log('当前页码发生改变')
      this.currentPage = val
      this.orderList()
    },
    toSubscriptionOrder(val) {
      this.$router.push({name: 'dataOrders', params: {soId: val}})
    }
  }
}
</script>

<style lang="less">
.suborderdialog{
  .el-dialog__header {
        background: #FFF;
        border-radius: 8px 8px 0 0;
        height: 1.25rem;
        .el-dialog__title {
            line-height: 24px;
            font-weight: 500;
            font-size: 14px;
            color: #303133;
        }
    }
}
.subordermanager{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 15px;
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a{
            color:#b4b8bb;
          }
        }
        li.active,li:hover {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
        li.fr{
          margin-left: 30px;
        }
      }
    }
  }
  .newftp{
    text-align: right;
    line-height: 36px;
    padding: 10px 0px 20px;
    a{
      display: inline-block;
      padding: 5px 12px;
      border-radius: 15px;
      color: #fff;
      background-color: #f14242;
      font-size: 12px;
      line-height: 18px;
      margin-right: 10px;
    }
  }
  .msg{
    font-size: 14px;
    padding: 18px 10px;
    span{
      color: red;
    }
  }
  .r-title{
    float: right;
    height: 60px;
    line-height: 60px;
    span{
      color: #f01400;
    }
  }
  .pages{
    text-align: right;
    padding-top: 15px;
  }
  .messagelist {
    .el-table__body tr:hover>td{
      background-color:#fef3f3;
    }
    .lookfor{
      background-color: #67c23a;
      color: #fff;
      padding: 3px 10px;
      border-radius: 4px;
      display: inline-block;
    }
    .cell{
      color:#333;
      i{
        font-size: 24px;
        margin-right: 5px;
        color: #ffb805;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/subscriptionOrdersList.vue